import { PRIVACY_POLICY, TERMS_OF_SERVICE, TERMS_OF_USE } from './constants';
export var LEGAL_DOCUMENTS = {
    termsOfUse: {
        pdf_key: TERMS_OF_USE,
        pdf_title: 'Michelin Terms of Use',
    },
    termsOfService: {
        pdf_key: TERMS_OF_SERVICE,
        pdf_title: 'Michelin Terms of Service',
    },
    privacyPolicy: {
        pdf_key: PRIVACY_POLICY,
        pdf_title: 'Michelin Privacy Policy',
    },
};
//# sourceMappingURL=legalDocuments.js.map